export default __webpack_public_path__ + "static/media/vegetarian.df06f230.jpg";